<p-iftalabel>
  <p-select
    [options]="vehicleCategories()"
    [ngModel]="value"
    (ngModelChange)="onModelChange($event)"
    (onBlur)="onBlur()"
    [disabled]="ngControl?.disabled ?? false"
    [filter]="true"
    [filterBy]="'code'"
    [optionLabel]="'code'"
    [optionValue]="'uid'"
    [showClear]="true"
    [placeholder]="placeholder()"
    [inputId]="inputId()"
    [class.ng-valid]="ngControl?.valid"
    [class.ng-invalid]="ngControl?.invalid"
    [class.ng-pristine]="ngControl?.pristine"
    [class.ng-dirty]="ngControl?.dirty"
    [class.ng-untouched]="ngControl?.untouched"
    [class.ng-touched]="ngControl?.touched"
    fluid="true">
    <ng-template let-vehicleCategory pTemplate="item">
      <span>
        <span class="font-monospace">{{ vehicleCategory.code }}</span>
        <span class="text-500"> {{ vehicleCategory.name }}</span>
      </span>
    </ng-template>
    <ng-template #dropdownicon>
      <i class="pi pi-car"></i>
    </ng-template>
  </p-select>
  <label [for]="inputId()">{{ label() }}</label>
</p-iftalabel>
